import { DateTime } from "luxon";
import { Desk, Floor, Office, Reservation, User, Zone } from "@/swagger/models";

export enum CheckinFilterValues {
    checkedIn,
    checkedInAndOut,
    checkedInNotOut,
    notCheckedIn,
}

export interface ReservationTableFilters {
    customerId: number;
    officeId?: number;
    floorId?: number;
    zoneId?: number;
    deskId?: number;
    userId?: number;
    checkin?: CheckinFilterValues;
    dates: [DateTime, DateTime];
    page: number;
    itemsPerPage: 20;

    sort: {
        field: string;
        direction: 1 | -1;
    };
}

export interface ReservationTableResult {
    loading: boolean;
    reservations: Reservation[];
    total: number;

    // For populating the filters
    offices: Office[];
    floors: Floor[];
    zones: Zone[];
    desks: Desk[];
    users: User[];
}

export type ReservationsTableInitialFilters = Partial<ReservationTableFilters> &
    Pick<ReservationTableFilters, "customerId">;
